// /* eslint-disable eslint-comments/disable-enable-pair */

import { makeApiCall } from '../../../_common/api.utils';
import { API_URL } from '../../../const';

// BANK ADD DETAILS FUNCTION
export const bankDetailsAdd = (bankData: any) => {
	const data = {
		AddBusinessTokenBank: bankData,
	};
	const url = `${API_URL}addBusinessBank`;
	return makeApiCall(url, data);
};

// FETCH BANK DETAILS FUNCTION
export const fetchBankDetails = (fetchData: any) => {
	const data = {
		GetBusinessBankToken: fetchData,
	};
	const url = `${API_URL}getBusinessBank`;
	return makeApiCall(url, data);
};

// UPDATE BANK DETAILS FUNCTION
export const updateBankDetails = (updateData: any) => {
	const data = {
		UpdateBusinessDetailsToken: updateData,
	};
	const url = `${API_URL}updateBusinessBank`;
	return makeApiCall(url, data);
};

// DELETE BANK DETAILS FUNCTION
export const deleteBankDetails = (deleteData: any) => {
	const data = {
		DeleteBusinessBankDetailsToken: deleteData,
	};
	const url = `${API_URL}deleteBusinessBank`;
	return makeApiCall(url, data);
};
